import { createAsyncThunk } from "@reduxjs/toolkit"

import { stopMessageProcessing } from "@/common/services/chat"

interface StopEmbedMessageArgs {
  chatId: string
  /** Public agent ID — the embed auth guard authenticates the anonymous stop request by it. */
  agentId: string
  deploymentId: string
  sessionId: string
}

interface StopEmbedMessageResult {
  chatId: string
  count: number
  workflowsStopped: number
}

/**
 * Thunk to stop message processing for an embed chat
 * Calls backend to cancel in-progress AI responses and workflows
 */
export const stopEmbedMessage = createAsyncThunk<StopEmbedMessageResult, StopEmbedMessageArgs>(
  "embedChat/stopMessage",
  async ({ chatId, agentId, deploymentId, sessionId }) => {
    const result = await stopMessageProcessing({
      chatId,
      agentId,
      sessionId,
      deploymentId
    })

    return {
      chatId,
      count: result.count,
      workflowsStopped: result.workflowsStopped
    }
  }
)
